import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';
import { LanguageProvider } from './contexts/LanguageContext';
import AppRouter from './components/AppRouter';
import ErrorBoundary from './components/ErrorBoundary';
import { analytics, initializeGA4 } from './components/AnalyticsTracker';
import './app.css';
import './index.css';

// Google Analytics 4 loads only when a measurement ID is configured at build time
// (Vercel env var REACT_APP_GA_MEASUREMENT_ID, e.g. G-XXXXXXXXXX).
const gaMeasurementId = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();
if (/^G-[A-Z0-9]+$/i.test(gaMeasurementId)) {
  initializeGA4(gaMeasurementId);
}

// Initialize analytics
analytics.trackPageView('app_loaded');

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        // Offline support is optional; never surface this as an app error.
        console.warn('Service worker not registered:', error && error.message);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <FeatureFlagsProvider>
              <ErrorBoundary>
                <AppRouter />
              </ErrorBoundary>
            </FeatureFlagsProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);